const axios = require('axios')
const querystring = require('querystring')

class MapMyApi {

  constructor (config) {
    this.updateConfig(config)
  }

  updateConfig (_config) {
    const config = Object.assign({}, this.config, _config)
    const { client, version, authToken, apiKey, root, migrationRoot } = config

    this.v = version
    this.migrationRoot = migrationRoot

    if (client) {
      this.client = client
    } else {
      this.client = axios.create({
        baseURL: root,
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
          'Api-Key': apiKey,
        },
      })
      this.client.interceptors.response.use(undefined, this._retryFailedRequest)
    }

    this.config = config
  }

  /**
   * Retry api calls once, if they failed with one of the
   * following error codes: 502, 503, 504.
   *
   * Useful in devint.
   *
   * @param  {Object} err
   */
  _retryFailedRequest (err) {
    const retryCode = [502, 503, 504].indexOf(err.status) !== -1
    if (retryCode && err.config && !err.config.__isRetryRequest) {
      err.config.__isRetryRequest = true
      return axios(err.config)
    }
    throw err
  }

  _stringify (params) {
    return params ? `?${querystring.stringify(params)}` : ''
  }

  static _addApi (apis) {
    Object.keys(apis).forEach((key) => { MapMyApi.prototype[key] = apis[key] })
  }

}

MapMyApi._addApi(require('./activityStory'))
MapMyApi._addApi(require('./activityTypes'))
MapMyApi._addApi(require('./courses'))
MapMyApi._addApi(require('./feed'))
MapMyApi._addApi(require('./geoip'))
MapMyApi._addApi(require('./goals'))
MapMyApi._addApi(require('./image'))
MapMyApi._addApi(require('./mobile'))
MapMyApi._addApi(require('./routes'))
MapMyApi._addApi(require('./users'))
MapMyApi._addApi(require('./migration'))
MapMyApi._addApi(require('./userGear'))
MapMyApi._addApi(require('./userStats'))
MapMyApi._addApi(require('./workouts'))
MapMyApi._addApi(require('./yearInReview'))

module.exports = MapMyApi



// WEBPACK FOOTER //
// ./shared/mapmy/api.js